module.exports = "mutation ($data: AccountSettingsInput!) {\n  AccountSettingsUpdate(data: $data) {\n    shop {\n      hideDefaultOnContract\n    }\n  }\n}\n"